import {createApp} from 'vue'
import DonationReceiptOverlay from './DonationReceiptOverlay'

const el = '[data-content=DonationReceiptOverlay]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((DonationReceiptOverlayDOM)=>{
            const readMoreUrl = DonationReceiptOverlayDOM.dataset.readMoreUrl
            Store.commit('main/set_page_overlay_content_data',{ readMoreUrl })
        })
    }
}